import { Injectable, inject } from '@angular/core';

import { DynamicLayoutService, OnFeatureInit, SlotName } from '@frontend/vanilla/core';
import { RtmsLayerConfig, RtmsSubscriberService } from '@frontend/vanilla/shared/rtms';

import { RtmsLayerComponent } from './components/rtms-layer.component';

@Injectable()
export class RtmsLayerBootstrapService implements OnFeatureInit {
    private rtmsSubscriberService = inject(RtmsSubscriberService);
    private rtmsClientConfig = inject(RtmsLayerConfig);
    private dynamicLayoutService = inject(DynamicLayoutService);

    onFeatureInit(): void {
        this.rtmsClientConfig.whenReady.subscribe(() => {
            if (this.rtmsClientConfig.version === 1) {
                this.rtmsSubscriberService.init();
                this.dynamicLayoutService.addComponent(SlotName.App, RtmsLayerComponent, null);
            }
        });
    }
}
